// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as SuspensionInfoEntityMapper from "../entity-mapper/SuspensionInfoEntityMapper.bs.js";
import * as SuspensionReasonEntityMapper from "../entity-mapper/SuspensionReasonEntityMapper.bs.js";

var execute = SuspensionInfoEntityMapper.execute;

var SuspensionInfoResponseConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var SuspensionInfoResponseConverter = partial_arg(SuspensionInfoResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = SuspensionReasonEntityMapper.execute;

var SuspensionReasonsResponseConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var SuspensionReasonsResponseConverter = partial_arg$1(SuspensionReasonsResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function unsuspend_api_response_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var success = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "success"), null));
  if (success.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              success: success._0
            }
          };
  }
  var e = success._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".success" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function decodeUnsuspendResponse(json, msisdn) {
  var decoded = DeccoUtils$Catalyst.resolveResult(unsuspend_api_response_decode(json), "UnsuspendResponse");
  return {
          message: decoded.success ? "Driver with MSISDN: " + msisdn + " is now un-suspended." : "Unsuspension failed",
          status: 200
        };
}

export {
  SuspensionInfoResponseConfig ,
  SuspensionInfoResponseConverter ,
  SuspensionReasonsResponseConfig ,
  SuspensionReasonsResponseConverter ,
  unsuspend_api_response_decode ,
  decodeUnsuspendResponse ,
  
}
/* SuspensionInfoResponseConverter Not a pure module */
